import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermission } from '../hooks/usePermission';
import { useAuth } from './AuthContext';

const RequirePermission = ({ children, permiso }) => {
  const { hasPermission } = usePermission();
  const { loading } = useAuth();

  // Mientras el contexto de autenticación carga los permisos, no mostramos nada
  if (loading) {
      return null; 
  }

  // Si el usuario NO tiene el permiso exacto, lo rebotamos al Home "/"
  if (!hasPermission(permiso)) {
    return <Navigate to="/ventas" replace />;
  }

  // Si tiene el permiso, lo dejamos renderizar la pantalla normalmente
  return children;
};

export default RequirePermission;